import { ApiService, HttpMethod } from '../_common/api.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TurfProRobot } from './models/turf-pro-robot.type';

@Injectable({
    providedIn: 'root'
})
export class TurfProApiService {

    private apiService: ApiService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(http: HttpClient) {
        this.apiService = new ApiService(http);
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    getRobots(): Observable<TurfProRobot[]> {
        return this.apiService.apiRequest<any>(TurfProApiService.getRobotUrl, HttpMethod.Get)
            .pipe(map((results: TurfProRobot[]) => results.map(r => new TurfProRobot(r))));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    private static get baseUrl(): string { return `${ApiService.baseApiUrl}turfPro`; }

    private static get getRobotUrl(): string { return `${TurfProApiService.baseUrl}/robots`; }
}
